import React, {
    useState,
    useEffect,

} from "react"
import { Tabs, Badge, Button } from './ot'
import ButtonGroup from "./button_group"
import { cn } from "./utils";
import { Eye, Edit, Share, Download, } from "lucide-react"
const BaseCardView1_8 = ({
    buttons = [
        <Button variant="outline" className="flex-1">
            <Eye className="h-4 w-4 mr-1" />
            查看
        </Button>,
        <Button className="flex-1">
            <Edit className="h-4 w-4 mr-1" />
            複製文案內容並編輯
        </Button>,
        <Button variant="ghost" size="sm">
            <Share className="h-4 w-4 mr-1" />
            分享
        </Button>,
        <Button variant="ghost" size="sm">
            <Download className="h-4 w-4 mr-1" />
            匯出
        </Button>,
        <Button variant="ghost" size="sm" className="text-red-600">
            刪除
        </Button>,
    ],
    buttonGroupsColumnsCount = [2, 3],
    buttonGroupClassName = "flex gap-2 mt-4",
    buttonItemClassName = "flex-1",
}, ref) => {

    let offset = 0;

    return (
        <>
            {buttonGroupsColumnsCount?.map((count, rowIndex) => {
                const thisRowButtons = buttons.slice(offset, offset + count);
                offset += count;
                return (
                    <ButtonGroup key={rowIndex} className={buttonGroupClassName}>
                        {thisRowButtons.map((button, i) => {
                            const newClassName = cn(button.props.className, buttonItemClassName);
                            return React.cloneElement(button, {
                                key: i,
                                className: newClassName,
                            });
                        })}
                    </ButtonGroup>
                );
            })}
        </>
    );
};

export default BaseCardView1_8;
